import { lazy } from "react";
import { Route } from "react-router-dom";
import RouteGuard from "@/components/RouteGuard";

const AdminDashboard = lazy(() => import("@/pages/AdminDashboard"));
const AdminConfiguracoes = lazy(() => import("@/pages/AdminConfiguracoes"));
const SelecionarAcademia = lazy(() => import("@/pages/SelecionarAcademia"));
const AdminCriteriosGraduacao = lazy(() => import("@/pages/AdminCriteriosGraduacao"));
const AdminAlunosLista = lazy(() => import("@/pages/AdminAlunosLista"));
const AdminAlunoNovo = lazy(() => import("@/pages/AdminAlunoNovo"));
const AdminAlunoDetalhe = lazy(() => import("@/pages/AdminAlunoDetalhe"));
const AdminTurmasLista = lazy(() => import("@/pages/AdminTurmasLista"));
const AdminTurmaNova = lazy(() => import("@/pages/AdminTurmaNova"));
const AdminTurmaDetalhe = lazy(() => import("@/pages/AdminTurmaDetalhe"));
const AdminProfessoresLista = lazy(() => import("@/pages/AdminProfessoresLista"));
const AdminProfessorNovo = lazy(() => import("@/pages/AdminProfessorNovo"));
const AdminProfessorDetalhe = lazy(() => import("@/pages/AdminProfessorDetalhe"));
const ConfiguracoesPlanos = lazy(() => import("@/pages/ConfiguracoesPlanos"));
const GerenciarAlunosPagantes = lazy(() => import("@/pages/GerenciarAlunosPagantes"));
const RelatorioInadimplencia = lazy(() => import("@/pages/RelatorioInadimplencia"));
const GestaoMetodosPagamento = lazy(() => import("@/pages/GestaoMetodosPagamento"));
const GestaoDescontosBolsas = lazy(() => import("@/pages/GestaoDescontosBolsas"));
const GestaoBolasPorAluno = lazy(() => import("@/pages/GestaoBolasPorAluno"));
const RelatorioBolsasImpacto = lazy(() => import("@/pages/RelatorioBolsasImpacto"));
const ConfiguracoesRetencaoFidelidade = lazy(() => import("@/pages/ConfiguracoesRetencaoFidelidade"));
const GestaoCancelamentosChurn = lazy(() => import("@/pages/GestaoCancelamentosChurn"));
const CrmGestaoRelacionamento = lazy(() => import("@/pages/CrmGestaoRelacionamento"));
const PlanoFinanceiroAcademia = lazy(() => import("@/pages/PlanoFinanceiroAcademia"));
const ModuloEventos = lazy(() => import("@/pages/ModuloEventos"));
const ImportarAlunos = lazy(() => import("@/pages/ImportarAlunos"));
const ManualAdminDashboard = lazy(() => import("@/pages/ManualAdminDashboard"));
const AdminComplianceDashboard = lazy(() => import("@/pages/AdminComplianceDashboard"));
const AdminRelatorioPresenca = lazy(() => import("@/pages/AdminRelatorioPresenca"));
const AdminHistoricoGraduacoes = lazy(() => import("@/pages/AdminHistoricoGraduacoes"));
const AdminNotificacoes = lazy(() => import("@/pages/AdminNotificacoes"));
const AdminWhatsAppTemplates = lazy(() => import("@/pages/AdminWhatsAppTemplates"));

const roles = ["developer", "admin"] as const;
const G = ({ children }: { children: React.ReactNode }) => (
  <RouteGuard allowedRoles={[...roles]}>{children}</RouteGuard>
);

export const adminRoutes = (
  <>
    <Route path="/importar_alunos" element={<G><ImportarAlunos /></G>} />
    <Route path="/selecionar_academia" element={<G><SelecionarAcademia /></G>} />
    <Route path="/admin_dashboard" element={<G><AdminDashboard /></G>} />
    <Route path="/admin_configuracoes" element={<G><AdminConfiguracoes /></G>} />
    <Route path="/admin_criterios_graduacao" element={<G><AdminCriteriosGraduacao /></G>} />
    <Route path="/admin_alunos" element={<G><AdminAlunosLista /></G>} />
    <Route path="/admin_aluno_novo" element={<G><AdminAlunoNovo /></G>} />
    <Route path="/admin_aluno_detalhe" element={<G><AdminAlunoDetalhe /></G>} />
    <Route path="/admin_aluno/:id" element={<G><AdminAlunoDetalhe /></G>} />
    <Route path="/admin_turmas" element={<G><AdminTurmasLista /></G>} />
    <Route path="/admin_turma_nova" element={<G><AdminTurmaNova /></G>} />
    <Route path="/admin_turma_detalhe" element={<G><AdminTurmaDetalhe /></G>} />
    <Route path="/admin_turma/:id" element={<G><AdminTurmaDetalhe /></G>} />
    <Route path="/admin_professores" element={<G><AdminProfessoresLista /></G>} />
    <Route path="/admin_professor_novo" element={<G><AdminProfessorNovo /></G>} />
    <Route path="/admin_professor_detalhe" element={<G><AdminProfessorDetalhe /></G>} />
    <Route path="/admin_professor/:id" element={<G><AdminProfessorDetalhe /></G>} />
    <Route path="/configuracoes_planos" element={<G><ConfiguracoesPlanos /></G>} />
    <Route path="/gerenciar_alunos_pagantes" element={<G><GerenciarAlunosPagantes /></G>} />
    <Route path="/relatorio_inadimplencia" element={<G><RelatorioInadimplencia /></G>} />
    <Route path="/gestao_metodos_pagamento" element={<G><GestaoMetodosPagamento /></G>} />
    <Route path="/gestao_descontos_bolsas" element={<G><GestaoDescontosBolsas /></G>} />
    <Route path="/gestao_bolsas_aluno" element={<G><GestaoBolasPorAluno /></G>} />
    <Route path="/relatorio_bolsas_impacto" element={<G><RelatorioBolsasImpacto /></G>} />
    <Route path="/configuracoes_retencao_fidelidade" element={<G><ConfiguracoesRetencaoFidelidade /></G>} />
    <Route path="/gestao_cancelamentos_churn" element={<G><GestaoCancelamentosChurn /></G>} />
    <Route path="/crm_gestao_relacionamento" element={<G><CrmGestaoRelacionamento /></G>} />
    <Route path="/plano_financeiro" element={<G><PlanoFinanceiroAcademia /></G>} />
    <Route path="/modulo_eventos" element={<G><ModuloEventos /></G>} />
    <Route path="/manual_admin" element={<G><ManualAdminDashboard /></G>} />
    <Route path="/admin_compliance" element={<G><AdminComplianceDashboard /></G>} />
    <Route path="/admin_relatorio_presenca" element={<G><AdminRelatorioPresenca /></G>} />
    <Route path="/admin_historico_graduacoes" element={<G><AdminHistoricoGraduacoes /></G>} />
    <Route path="/admin_notificacoes" element={<G><AdminNotificacoes /></G>} />
    <Route path="/admin_whatsapp_templates" element={<G><AdminWhatsAppTemplates /></G>} />
  </>
);
